module.exports = __webpack_public_path__ + "static/media/error.90b8e501.png";